module.exports = __webpack_public_path__ + "img/small-vk-reklama.e7b7ea24.svg";